import bem from 'utils/bem';

export const block = bem('rename-clip-modal');
